export const changePassword = {
    title: 'Change password',
    oldPasswordLabel: 'Old password',
    newPasswordLabel: 'New password',
    confirmPasswordLabel: 'Confirm password',
    password: 'Password',
    save: 'save change',
    cancel: 'cancel',
};
